// BL-177 Gate 17d — Action Pill Standard v1: the look of a submenu option pill.
//
// Copied from the therideatl.com contact launcher (.fab-item / .fab-menu in the site's
// assets/site.css). ActionPillMenu writes these onto its menu as CSS custom properties, and the
// .ia-action-pill-* rules in src/styles/global.css only ever read the properties, so this file is
// the one place the numbers live.
// Gate 17e (v1.01, Val 2026-09-30): smaller pills — 36px (compact 30px), ~0.68rem text, 10px side
// padding, 18px icon, 8px apart. Shape, border, glass background and turquoise hover unchanged.
// Standard: Docs/Build_Execution/Platform/IntelAgent_Action_Pill_Standard_v1_01.md

import { MENU_CLOSE_FADE_MS, MENU_ITEM_RISE_PX } from '../../lib/uiMotion';

export const ACTION_PILL_TOKENS = Object.freeze({
    height: 26,
    compactHeight: 24,
    radius: 999,
    gap: 8,
    paddingX: 7,
    border: 'rgba(214, 218, 224, 0.35)',
    background: 'rgba(12, 12, 14, 0.9)',
    blur: 12,
    shadow: '0 10px 24px rgba(0, 0, 0, 0.5)',
    text: '#eef0f2',
    letterSpacing: '0.12em',
    fontWeight: 700,
    fontSize: '0.62rem',
    compactFontSize: '0.64rem',
    iconSize: 18,
    accent: '#03B7C9',
    glow: '0 0 18px rgba(3, 183, 201, 0.4)',
    ringFrom: 'rgba(3, 183, 201, 0.75)',
    ringTo: 'rgba(3, 183, 201, 0)',
    ringSpread: 14,
    ringMs: 1300,
    easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
    labelRevealMs: 450,
    labelMaxWidth: '18rem',
    selected: '#22C55E',
});

export function actionPillCssVars(size = 'default') {
    const t = ACTION_PILL_TOKENS;
    const compact = size === 'compact';
    return {
        '--ia-pill-height': `${compact ? t.compactHeight : t.height}px`,
        '--ia-pill-radius': `${t.radius}px`,
        '--ia-pill-gap': `${t.gap}px`,
        '--ia-pill-pad-x': `${t.paddingX}px`,
        '--ia-pill-border': t.border,
        '--ia-pill-bg': t.background,
        '--ia-pill-blur': `${t.blur}px`,
        '--ia-pill-shadow': t.shadow,
        '--ia-pill-text': t.text,
        '--ia-pill-tracking': t.letterSpacing,
        '--ia-pill-weight': t.fontWeight,
        '--ia-pill-font-size': compact ? t.compactFontSize : t.fontSize,
        '--ia-pill-icon-size': `${t.iconSize}px`,
        '--ia-pill-accent': t.accent,
        '--ia-pill-glow': t.glow,
        '--ia-pill-ring-from': t.ringFrom,
        '--ia-pill-ring-to': t.ringTo,
        '--ia-pill-ring-spread': `${t.ringSpread}px`,
        '--ia-pill-ring-ms': `${t.ringMs}ms`,
        '--ia-pill-easing': t.easing,
        '--ia-pill-label-ms': `${t.labelRevealMs}ms`,
        '--ia-pill-label-max': t.labelMaxWidth,
        '--ia-pill-selected': t.selected,
        '--ia-pill-rise': `${MENU_ITEM_RISE_PX}px`,
        '--ia-pill-fade-ms': `${MENU_CLOSE_FADE_MS}ms`,
    };
}
